import { render, staticRenderFns } from "./AdminPolicy.vue?vue&type=template&id=183dd58a"
import script from "./AdminPolicy.vue?vue&type=script&lang=js"
export * from "./AdminPolicy.vue?vue&type=script&lang=js"
import style0 from "./AdminPolicy.vue?vue&type=style&index=0&id=183dd58a&prod&lang=scss"
import style1 from "./AdminPolicy.vue?vue&type=style&index=1&id=183dd58a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports